module.exports = __webpack_public_path__ + "static/media/ball_3_8.2f63aee4.mp3";